import React from 'react';
import { hydrate } from 'react-dom';
import { App } from './src/components/App';

import './styles.css';

const root = document.getElementById('blink-effect-podlet-root');
const props = JSON.parse(root.dataset.props) || '';

class BlinkEffectPodlet extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML += `
            <link
                rel='stylesheet'
                type='text/css'
                href='https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css'
                onload="(function(){ const event = new Event('podlet-load'); document.dispatchEvent(event); })(this)"
            />
            <style>
            
        .marketing-heading {
            font-size: 34px;
            line-height: 41px;
        }
       @media (min-width: 480px) {
            .marketing-heading {
                font-size: 47px;
                line-height: 58px;
            } 
       }
            </style>
            ${this.innerHTML}
        `;

        this.innerHTML = hydrate(<App {...props} />, root);
    }
}

customElements.define('blink-effect-podlet', BlinkEffectPodlet);
